import { render } from "./PriceListMenu.vue?vue&type=template&id=5acb3d12&scoped=true"
import script from "./PriceListMenu.vue?vue&type=script&lang=js"
export * from "./PriceListMenu.vue?vue&type=script&lang=js"

import "./PriceListMenu.vue?vue&type=style&index=0&id=5acb3d12&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acb3d12"]])

export default __exports__